<template>
  <header :class="['bg-black text-white fixed top-0 z-30 h-[68px]', 
                  isMenuPage ? 'left-[5.5rem] right-0' : 'left-0 right-0']">
    <div class="px-4 py-3 flex justify-between items-center max-w-screen-lg mx-auto">
      <!-- Logo und Titel (nur sichtbar, wenn die Sidebar nicht existiert) -->
      <div class="flex items-center">
        <img v-if="!isMenuPage" src="@/assets/Ensu-logo.png" alt="Restaurant Logo" class="h-10 w-auto mr-3" /> 
        <h1 class="text-xl font-bold">Ensu Kitchen</h1>
      </div>
      
      <!-- Aktionen -->
      <div class="flex items-center space-x-5">
        <!-- Meine Bestellungen Button -->
        <router-link to="/order-status" class="group flex items-center text-gray-300 hover:text-white transition-colors duration-200">
          <div class="relative flex items-center">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
            </svg>
            <span class="hidden sm:inline text-sm font-medium group-hover:text-[#E2553D]">{{ $t('menu.button.myOrders') }}</span>
          </div>
        </router-link>

        <LanguageSwitcher />
        
        <!-- Warenkorb Icon -->
        <router-link to="/cart" class="relative text-gray-300 hover:text-white transition-colors duration-200 group">
          <div class="flex items-center">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
            </svg>
            <span class="hidden sm:inline text-sm font-medium group-hover:text-[#E2553D]">{{ $t('menu.button.cart') }}</span>
            <!-- Badge für Artikelanzahl -->
            <span v-if="cartStore.totalItems > 0" 
                  :key="cartStore.totalItems" 
                  class="absolute -top-2 -right-2 bg-[#E2553D] text-white text-xs font-bold rounded-full h-5 w-5 flex items-center justify-center animate-pulse-once">
              {{ cartStore.totalItems }}
            </span>
          </div>
        </router-link>
      </div>
    </div>
  </header>
</template>

<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import LanguageSwitcher from '@/components/common/LanguageSwitcher.vue'
import { useCartStore } from '@/stores/cart'; // Import Cart Store

const route = useRoute();
const cartStore = useCartStore(); // Initialize Cart Store

// Prüfen, ob wir auf der MenuView-Seite sind
const isMenuPage = computed(() => {
  return route.path.includes('/menu') || route.name === 'MenuView';
});
</script>

<style scoped>
/* Styling nach Bedarf */
@keyframes pulse-once {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.2); }
}
.animate-pulse-once {
  animation: pulse-once 0.3s ease-out;
}
</style> 